import {DI_VARIATIONS} from '@/src/config/di/types'

import {PageFunctionKey} from '@/src/core/domain/page/functions/types'

export const PageFetchMapping: Partial<Record<PageFunctionKey, ValuesOf<typeof DI_VARIATIONS>>> = {
  favourite: DI_VARIATIONS.FavouriteFetchOptionsFactoryProxy,
  'profile-favourite': DI_VARIATIONS.FavouriteFetchOptionsFactoryProxy,
  login: DI_VARIATIONS.LoginFetchOptionsFactoryProxy,
  order: DI_VARIATIONS.OrderFetchOptionsFactoryProxy,
  cart: DI_VARIATIONS.BasketFetchOptionsFactoryProxy,
  profile: DI_VARIATIONS.ProfileFetchOptionsFactoryProxy,
  certificates: DI_VARIATIONS.CertificatesFetchOptionsFactoryProxy,
  'profile-reservation': DI_VARIATIONS.ProfileReservationsFetchOptionsFactoryProxy,
  static: DI_VARIATIONS.StaticFetchOptionsFactoryProxy,
  profile_root: DI_VARIATIONS.ProfileRootFetchOptionsFactoryProxy,
}
